export const NAME = 'resetpassword';

// User password reset initialize procedure constants
export const REQUEST_PASSWORD_RESET_INIT_USERNAME = 'REQUEST_PASSWORD_RESET_INIT_USERNAME';
export const SUCCESS_PASSWORD_RESET_INIT_USERNAME = 'SUCCESS_PASSWORD_RESET_INIT_USERNAME';
export const FAILURE_PASSWORD_RESET_INIT_USERNAME = 'FAILURE_PASSWORD_RESET_INIT_USERNAME';
export const REQUEST_PASSWORD_RESET_INIT_EMAIL = 'REQUEST_PASSWORD_RESET_INIT_EMAIL';
export const SUCCESS_PASSWORD_RESET_INIT_EMAIL = 'SUCCESS_PASSWORD_RESET_INIT_EMAIL';
export const FAILURE_PASSWORD_RESET_INIT_EMAIL = 'FAILURE_PASSWORD_RESET_INIT_EMAIL';

// User password reset start procedure constants
export const REQUEST_PASSWORD_RESET_COMMIT = 'REQUEST_PASSWORD_RESET_COMMIT';
export const SUCCESS_PASSWORD_RESET_COMMIT = 'SUCCESS_PASSWORD_RESET_COMMIT';
export const FAILURE_PASSWORD_RESET_COMMIT = 'FAILURE_PASSWORD_RESET_COMMIT';



// WEBPACK FOOTER //
// ./src/services/authentication/resetpassword/constants.js